import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import {
  generateBrandsInsightStrategy,
  generateEmojiInsightStrategy,
  generateHashtagsInsightStrategy,
  generatePeopleInsightStrategy,
  generateTermsInsightStrategy,
  generateThingsInsightStrategy
} from 'utils/insightModal/strategy/searchFilterComposing'

const useSearchFilterComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const searchFilterComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.TERMS:
        return generateTermsInsightStrategy()
      case InsightViewOption.HASHTAGS:
        return generateHashtagsInsightStrategy()
      case InsightViewOption.EMOJIS_GROUP:
      case InsightViewOption.EMOJIS_EMOTION:
      case InsightViewOption.EMOJIS_EMOJI:
        return generateEmojiInsightStrategy()
      case InsightViewOption.BRANDS:
        return generateBrandsInsightStrategy()
      case InsightViewOption.PEOPLE:
        return generatePeopleInsightStrategy()
      case InsightViewOption.THINGS:
        return generateThingsInsightStrategy()
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption])

  return searchFilterComposingStrategy
}

export default useSearchFilterComposingStrategy
